<template>
  <div>
    <SiteHeader />
    <router-view v-slot="{ Component }">
      <keep-alive>
        <component :is="Component" />
      </keep-alive>
    </router-view>
    <SiteFooter />
  </div>
</template>

<script>
import { onMounted } from 'vue'
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import feather from 'feather-icons'
import { WOW } from 'wowjs'

export default {
  name: 'App',
  components: {
    SiteHeader: Header,
    SiteFooter: Footer
  },
  setup() {
    onMounted(() => {
      // Load CSS files
      const cssFiles = [
        '/css/animate.css',
        '/css/magnific-popup.min.css',
        '/css/owl.carousel.min.css',
        '/css/odometer.css',
        '/css/slick.css',
        '/css/style.css',
        '/css/responsive.css'
      ]
      
      cssFiles.forEach(file => {
        const link = document.createElement('link')
        link.rel = 'stylesheet'
        link.href = file
        document.head.appendChild(link)
      })
      
      // Initialize Feather Icons
      feather.replace()
      
      // Initialize WOW.js for animations
      new WOW({
        boxClass: 'wow',
        animateClass: 'animated',
        offset: 20,
        mobile: true,
        live: true
      }).init()
      
      // Handle sticky header
      window.addEventListener('scroll', () => {
        if (window.scrollY > 120) {
          document.querySelector('.startp-nav')?.classList.add('is-sticky')
        } else {
          document.querySelector('.startp-nav')?.classList.remove('is-sticky')
        }
      })
    })
  }
}
</script>

<style>
/* Additional styles loaded dynamically */
</style>
